import React from "react";
import { useStaticQuery, graphql } from "gatsby";

import "./style.scss";

const EEnjoyZipcrewCard = (props) => {
  const icons = useStaticQuery(graphql`
    query {
      icon1: file(relativePath: { eq: "images/usdc-buy-lock-up.svg" }) {
        publicURL
      }
      icon2: file(relativePath: { eq: "images/ltc-buy-lock-up.svg" }) {
        publicURL
      }
      icon3: file(relativePath: { eq: "images/coins-buy-lock-up-left.svg" }) {
        publicURL
      }
      icon4: file(relativePath: { eq: "images/coins-buy-lock-up-right.svg" }) {
        publicURL
      }
    }
  `);

  const CoinIcons = ({ icons }) =>
    Object.values(icons).map((icon, i) => (
      <img
        key={`earn-enjoy-zipcrew-card__coin-icon-${i}`}
        src={icon.publicURL}
        className={`img-fluid card-wrapper-icon icon-${i + 1}`}
      />
    ));

  return (
    <div className="earn-enjoy-zipcrew-card card-wrapper">
      <CoinIcons icons={icons} />

      <div className="card mb-3">
        <div className="row no-gutters">
          <div className="col-md-7 card-body px-5 d-flex flex-column align-self-center">
            <h3
              className="card-title my-4"
              dangerouslySetInnerHTML={{
                __html: props.content.edges[0].node.acfPartials.pHeading,
              }}
            />
            <div
              className="card-text"
              dangerouslySetInnerHTML={{
                __html: props.content.edges[0].node.acfPartials.pContent,
              }}
            />
            <div className="my-4">
              <a
                className="button button-primary"
                href={props.content.edges[0].node.acfPartials.pButtonUrl}
                rel="noreferrer noopener"
              >
                {props.content.edges[0].node.acfPartials.pButtonText}
              </a>
            </div>
          </div>
          <div className="col-md-5 d-flex align-items-center img-holder">
            <img
              src={
                props.content.edges[0].node.acfPartials.pIcon.localFile
                  .publicURL
              }
              className="card-img"
              alt="Buy and lock up ZMTs to be ZipCrew"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EEnjoyZipcrewCard;
